import { createSlice } from "@reduxjs/toolkit";
import { allDenomination, allTypes } from "../../Helpers/Common/CommonComponent";
const sortingFechingObj = {
   location: false,
   controlID: false,
};

export const sortNewRow = {
   productID: "",
   units: "",
   STC: "",
   switch: false,//default state in units so switch is false,
   filterTypes: JSON.parse(JSON.stringify(allTypes)),
   filterDenoms: JSON.parse(JSON.stringify(allDenomination)),
};

const initialState = {
   allLocationData: [],
   allControlIdData: [],
   allProductData: [],
   isFetching: sortingFechingObj
};

export const sortingSlice = createSlice({
   name: "sorting",
   initialState: initialState,
   reducers: {
      setAllLocationData: (state, action) => {
         state.allLocationData = action.payload;
      },
      setAllControlIdData: (state, action) => {
         state.allControlIdData = action.payload;
      },
      setAllProductData: (state, action) => {
         state.allProductData = action.payload;
      },
      setIsFetching: (state, action) => {
         state.isFetching = action.payload;
      },
   },
});
